if (!customElements.get("installer-vehicles")) {
  customElements.define(
    "installer-vehicles",
    class Installervehicles extends HTMLElement {
      constructor() {
        super();
        this.apiLocation = `${window.appEndPoint}/get-data?shop=${Shopify.shop}`;
        this.yearSelector = this.querySelector("[js-year-selector]");
        this.makeSelector = this.querySelector("[js-make-selector]");
        this.modelSelector = this.querySelector("[js-model-selector]");
        this.init();
      }

      init() {
        console.log(localStorage.getItem("vehicle"));
        if (localStorage.getItem("vehicle")) {
          const vehicleData = JSON.parse(localStorage.getItem("vehicle"));
          this.querySelector(
            ".show-selector"
          ).textContent = `${vehicleData.title}`;
          if (vehicleData.hasOwnProperty("attributes")) {
            this.populate(vehicleData.attributes);
          }
          this.querySelector(".iv-selector-container").classList.remove("flex");
          this.querySelector(".iv-selector-container").classList.add("hidden");
          this.querySelector(".iv-product-container").classList.remove(
            "hidden"
          );
          this.querySelector(".iv-product-container").classList.add("flex");
        }

        this.querySelector(".iv-change-handler").addEventListener(
          "click",
          () => {
            this.querySelector(".iv-selector-container").classList.remove(
              "hidden"
            );
            this.querySelector(".iv-selector-container").classList.add("flex");
            this.querySelector(".iv-product-container").classList.remove(
              "flex"
            );
            this.querySelector(".iv-product-container").classList.add("hidden");
          }
        );

        this.querySelector(".load-wraper").classList.add("hidden");
        this.querySelector(".load-wraper").classList.remove("flex");
        this.querySelector(".installer-vehicles--header").classList.remove(
          "hidden"
        );
        this.querySelector(".installer-vehicles--header").classList.add("flex");

        this.actionswithToken();
      }

      async populate(items) {
        items.forEach((item) => {
          if (item.endpoint != "" && item.endpoint != null) {
            this.querySelector(".product-type-container").insertAdjacentHTML(
              "beforeend",
              `
                <a href="https://${window.shopEndPoint}${item.endpoint}">
                  <div class="max-w-sm p-2 border border-gray-200 flex flex-col items-center w-32 justify-center justify-items-center rounded shadow md:p-4 dark:border-gray-700">
                      <div class="h-20 w-20 mb-4 bg-gray-300 rounded dark:bg-gray-700">
                        <img src="${item.icon}" alt="${item.title}" class="w-20 h-20 rounded">
                      </div>
                      <div class="text-md rounded-full">${item.title}</div>
                  </div>
                </a>
              `
            );
            this.querySelector(
              ".product-type-container-default"
            ).insertAdjacentHTML(
              "beforeend",
              `
                <a href="https://${window.shopEndPoint}${item.endpoint}">
                  <div class="max-w-sm p-2 border border-gray-200 flex flex-col items-center w-32 justify-center justify-items-center rounded shadow md:p-4 dark:border-gray-700">
                      <div class="h-20 w-20 mb-4 bg-gray-300 rounded dark:bg-gray-700">
                        <img src="${item.icon}" alt="${item.title}" class="w-20 h-20 rounded">
                      </div>
                      <div class="text-md rounded-full">${item.title}</div>
                  </div>
                </a>
              `
            );
          }
        });
      }

      async actionswithToken() {
        await this.getYearList();
        await this.getMakeList();
        await this.getModelList();
        await this.getVehicles();
      }

      async getVehicles() {
        this.modelSelector.addEventListener(`change`, async (e) => {
          const selectedModel = e.target.value,
            selectedYear = this.yearSelector.value,
            selectedMake = this.makeSelector.value;

          const response = await this.requestGet(
            `${this.apiLocation}&year=${selectedYear}&make=${selectedMake}&model=${selectedModel}`
          );

          this.querySelector(".product-type-selector").classList.remove(
            "hidden"
          );
          this.querySelector(".product-type-selector").classList.add("flex");

          localStorage.setItem(
            "vehicle",
            JSON.stringify({
              id: response.id,
              year: this.yearSelector.options[this.yearSelector.selectedIndex]
                .text,
              make: this.makeSelector.options[this.makeSelector.selectedIndex]
                .text,
              model: e.target.options[e.target.selectedIndex].text,
              title: response.title,
              attributes: response.attributes,
            })
          );

          this.querySelector(".product-type-container").innerHTML = "";

          await this.populate(response.attributes);

          this.querySelector(".product-type-loader").classList.remove("flex");
          this.querySelector(".product-type-loader").classList.add("hidden");
          this.querySelector(".product-type-container").classList.remove(
            "hidden"
          );
          this.querySelector(".product-type-container").classList.add("flex");
        });
      }

      async getModelList() {
        this.makeSelector.addEventListener(`change`, async (e) => {
          const selectedMake = e.target.value,
            selectedYear = this.yearSelector.value;

          const modelsRes = await this.requestGet(
            `${this.apiLocation}&year=${selectedYear}&make=${selectedMake}`
          );
          this.modelSelector.innerHTML = `<option value disabled selected hidden>Model</option>`;
          modelsRes.forEach((item) => {
            this.modelSelector.insertAdjacentHTML(
              "beforeend",
              `
                <option value="${item.id}">${item.model}</option>
              `
            );
          });
          this.modelSelector.disabled = false;
        });
      }

      async getMakeList() {
        this.yearSelector.addEventListener(`change`, async (e) => {
          const selectedYear = e.target.value;
          const makesRes = await this.requestGet(
            `${this.apiLocation}&year=${selectedYear}`
          );
          this.makeSelector.innerHTML = `<option value disabled selected hidden>Make</option>`;
          makesRes.forEach((item) => {
            this.makeSelector.insertAdjacentHTML(
              "beforeend",
              `
                <option value="${item.id}">${item.make}</option>
              `
            );
          });
          this.makeSelector.disabled = false;
        });
      }

      async getYearList() {
        const response = await this.requestGet(this.apiLocation);
        response.forEach((item) => {
          this.yearSelector.insertAdjacentHTML(
            "beforeend",
            `
              <option value="${item}">${item}</option>
            `
          );
        });
        this.yearSelector.disabled = false;
      }

      async requestGet(endPoint) {
        const getApiData = await fetch(endPoint);
        const response = await getApiData.json();
        return response;
      }
    }
  );
}
